import { Helmet } from 'react-helmet'
import { Navigate } from 'react-router-dom'
import Cookies from 'js-cookie'
import { AUTHORIZATION_COOKE, SUBSCRIPTION_PRICE_A_MONTH } from '../../constants'
import { getDailyHomeDestination } from '../../utils/dailyHome'
import LandingPage from '../landing/LandingPage'

const LandingScreen = () => {
    if (Cookies.get(AUTHORIZATION_COOKE)) {
        return <Navigate to={getDailyHomeDestination()} replace />
    }

    return (
        <>
            <Helmet>
                <title>General Task - Tasks are cheap. Time is not.</title>
                <meta
                    name="description"
                    content={`General Task connects tasks, goals, and Google Calendar so scheduled work counts toward the goal. Only ${SUBSCRIPTION_PRICE_A_MONTH}.`}
                />
            </Helmet>
            <LandingPage />
        </>
    )
}

export default LandingScreen
